<template>
    <customModal :containersm="true" :footerShow="true" @closeModal="close()">
        <template #title>
            {{ heading }}
        </template>

        <template #body>
            <label class="col-form-label">Comments</label>
            <textarea
                class="form-control message-input"
                name="message"
                placeholder="Enter your comments here"
                v-model="localComments"
            ></textarea>
        </template>

        <template #footer>
            <div class="text-center">
                <button
                    type="button"
                    class="btn btn-green-new btn-sm py-0 text-white mr-2"
                    :disabled="isLoading"
                    @click="ActionSubmit(true)"
                >
                    <i v-if="isLoading && lastAction === true" class="fa fa-spinner fa-spin mr-1"></i>
                    {{ action1Label }}
                </button>
                <button
                    type="button"
                    class="btn btn-danger-new btn-sm py-0 px-3 mr-2"
                    :disabled="isLoading"
                    @click="ActionSubmit(false)"
                >
                    <i v-if="isLoading && lastAction === false" class="fa fa-spinner fa-spin mr-1"></i>
                    {{ action2Label }}
                </button>
            </div>
        </template>
    </customModal>
</template>

<script src="./GenericApproveRejectModal.js"></script>

<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/css/custom.css";

.btn-green-new {
    color: #fff;
    background-color: #1ab394;
    border: none;
}

.btn-danger-new {
    color: #fff;
    background-color: #ed5565;
    border: none;
}

.btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.message-input {
    resize: vertical;
    min-height: 100px;
}
</style>